import { render, staticRenderFns } from "./selectPerson.vue?vue&type=template&id=0ecdbd72&scoped=true"
import script from "./selectPerson.vue?vue&type=script&lang=js"
export * from "./selectPerson.vue?vue&type=script&lang=js"
import style0 from "./selectPerson.vue?vue&type=style&index=0&id=0ecdbd72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecdbd72",
  null
  
)

export default component.exports